export default __webpack_public_path__ + "static/media/helen.a769d8e7.jpg";